import React, { useState } from 'react';
import axios from 'axios';

// Gunicorn port 8002 ke sath configuration
const BASE_URL = window.location.hostname === 'localhost'
    ? 'http://127.0.0.1:8002'
    : 'https://likaiev.com';

const Contact = () => {
    // Form state management
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phone: '',
        message: ''
    });

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            // Backend URL ke sath POST request
            await axios.post(`${BASE_URL}/api/enquiry/`, formData);
            alert("Message sent successfully!");
            setFormData({ name: '', email: '', phone: '', message: '' });
        } catch (error) {
            console.error("Error submitting message:", error);
            alert("Failed to send message. Please try again.");
        }
    };

    return (
        <div className="bg-gray-50 min-h-screen">
            {/* Banner Section with Safe Inline Style */}
            <div
                className="relative h-[300px] w-full bg-cover bg-center flex items-center justify-center"
                style={{ backgroundImage: "url('/banner1.jpg')" }}
            >
                <div className="absolute inset-0 bg-blue-900/60"></div>
                <h1 className="relative z-10 text-5xl font-bold text-white tracking-widest text-center">
                    CONTACT US
                </h1>
            </div>

            <div className="container mx-auto px-6 py-16">
                <div className="grid lg:grid-cols-2 gap-12">
                    {/* Left: Info & Map */}
                    <div className="space-y-8">
                        <div className="space-y-4">
                            <div className="bg-blue-900 text-white p-6 rounded-lg flex items-center gap-4">
                                <span className="text-3xl">📍</span>
                                <p>WORKS: Plot No. 16, Bhoorgarhi Road, Dasna, Ghaziabad, UP - 201015</p>
                            </div>
                            <div className="bg-blue-900 text-white p-6 rounded-lg flex items-center gap-4">
                                <span className="text-3xl">📞</span>
                                <p>+91-7982747220, 8447157932, 0120-2812290</p>
                            </div>
                            <div className="bg-blue-900 text-white p-6 rounded-lg flex items-center gap-4">
                                <span className="text-3xl">✉️</span>
                                <p>likaievindia@gmail.com, contact@likaiev.com</p>
                            </div>
                        </div>

                        <div className="rounded-2xl overflow-hidden shadow-lg h-[300px]">
                            <iframe
                                title="Map"
                                src="https://www.google.com/maps/embed?pb=..."
                                width="100%" height="100%" frameBorder="0" style={{ border: 0 }} allowFullScreen="" aria-hidden="false" tabIndex="0">
                            </iframe>
                        </div>
                    </div>

                    {/* Right: Enquiry Form (Database Connected) */}
                    <div className="bg-white p-10 rounded-2xl shadow-2xl border border-gray-100">
                        <h2 className="text-3xl font-bold text-blue-900 mb-6">Send Us A Message</h2>
                        <form onSubmit={handleSubmit} className="space-y-6">
                            <input
                                name="name" type="text" placeholder="Full Name"
                                value={formData.name} onChange={handleChange}
                                className="w-full p-4 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-900 outline-none" required
                            />
                            <input
                                name="email" type="email" placeholder="E-Mail Address"
                                value={formData.email} onChange={handleChange}
                                className="w-full p-4 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-900 outline-none" required
                            />
                            <input
                                name="phone" type="tel" placeholder="Phone Number"
                                value={formData.phone} onChange={handleChange}
                                className="w-full p-4 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-900 outline-none"
                            />
                            <textarea
                                name="message" placeholder="Your Requirement / Message" rows="5"
                                value={formData.message} onChange={handleChange}
                                className="w-full p-4 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-900 outline-none"
                            ></textarea>
                            <button type="submit" className="w-full bg-blue-900 text-white py-4 rounded-lg font-bold text-lg hover:bg-orange-600 transition duration-300">
                                SUBMIT MESSAGE
                            </button>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Contact;